// Import model
import { DataviewProjectSelectionResponse } from '../models/DataviewProjectSelectionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProjectSelectionRequest } from '../models/FilterProjectSelectionRequest';
import { ProjectSelection } from '../models/ProjectSelection';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProjectSelectionRequestSerializer } from './FilterProjectSelectionRequestSerializer';
import { ProjectSelectionSerializer } from './ProjectSelectionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProjectSelectionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProjectSelectionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProjectSelectionResponse instance
   */
  static deserialize(json: string): DataviewProjectSelectionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProjectSelectionResponse instance
   */
  static fromObject(obj: any): DataviewProjectSelectionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProjectSelectionResponse');
    }


    const instance: DataviewProjectSelectionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProjectSelectionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProjectSelectionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProjectSelectionResponse instances
   */
  static deserializeArray(json: string): DataviewProjectSelectionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProjectSelectionResponse instance to a JSON string
   */
  static serialize(instance: DataviewProjectSelectionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProjectSelectionResponse instance to a plain object
   */
  static toObject(instance: DataviewProjectSelectionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProjectSelectionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProjectSelectionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProjectSelectionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProjectSelectionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
